export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
// somewhat arbitrary, google has their own "weak password" detection
export const MINIMUM_PASSWORD_LENGTH = 8
